import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Router,
  Routes,
} from "react-router-dom";
import constants from "../common/constants.js";
import Login from "../container/Login/Login.js";
import Register from "../container/Register/Register.js";
import Dashboard from "../container/Dashboard/Dashboard.js";
import { Container } from "@mui/material";
import Colors from "./Colors.js";
import { getSession } from "./SessionManager.js";
import { SessionExpiryPopup } from "./SessionExpiryPopup.js";

import Users from "../container/Users/Users.js";
import AddNewReward from "../container/AddNewReward/AddNewReward.js";
import ProfilePage from "../container/Profile/Profile.js";
import ViewDetails from "../container/viewDetails/ViewDetails.js";
import AddNewAward from "../container/AddNewReward/AddNewReward.js";
import CreateAbha from "../container/Register/CreateAbha.js";
import AbhaProfile from "../container/CreateABHA/AbhaProfile/AbhaProfile.js";

export const Navigation = () => {
  const isAuthenticated =
    getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN) != null;
  return (
    <div style={{ minHeight: "50vh" }}>
      <Container
        maxWidth="100%"
        sx={{
          display: "flex",
          pl: 0,
          pr: 0,
          minHeight: "100vh",
          height: "auto",
          bgcolor: Colors.MCHI_CONTAINER_BACKGROUND,
        }}
      >
        <Routes>
          {/* Default Route */}
          <Route path="/" element={<Navigate to="/landing-page" replace />} />
          {/* Authentication */}

          <Route path={constants.PATH_PROFILE} element={<ProfilePage />} />

          <Route path={constants.PATH_LOGIN} element={<Login />} />
          <Route path={constants.PATH_REGISTER} element={<Register />} />
          <Route path={constants.PATH_CREATE_ABHA} element={<CreateAbha />} />
          <Route path={constants.PATH_ABHA_PROFILE} element={<AbhaProfile />} />

          {/* <Route path="/login-otp" element={<LoginOTP />} /> */}

          {isAuthenticated && (
            <React.Fragment>
              {/* Dashboard */}
              <Route path={constants.PATH_DASHBOARD} element={<Dashboard />} />

              <Route
                path={constants.PATH_ADD_NEW_REWARD}
                element={<AddNewAward />}
              />
              <Route
                path={constants.PATH_VIEW_DETAILS}
                element={<ViewDetails />}
              />
              {/* <Route path="/admin-dashboard" element={<AdminDashboard />} /> */}

              {/* Request and Response */}

              {/* User Management */}
              <Route path={constants.PATH_USERS} element={<Users />} />
            </React.Fragment>
          )}
          {/* Catch-all Route for Unauthenticated Users */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Container>
    </div>
  );
};
